import { create } from "zustand";
import {
  getIVRBookings,
  getMedRepBooking,
  getOverDueTasks,
  putBreakDays,
} from "../api";

export const useEditBreak = create(() => ({
  editBreakDays: async (id, breakDays, setToaster) => {
    setToaster("Break Days", "Editing Break Day", "success");
    try {
      await putBreakDays(id, breakDays);
      setToaster("Break Days", "Break Day edited successfully", "success");
    } catch (error) {
      setToaster("Break Days", "Failed to edited Break Day", "danger");
    }
  },
}));

export const useOverDueTask = create((set) => ({
  overDueTaskData: {},
  fetchOverDueTask: async (id, startDate, endDate) => {
    try {
      const response = await getOverDueTasks(id, startDate, endDate);
      set({ overDueTaskData: response.data });
    } catch (error) {}
  },
}));

export const useMedRepBookings = create((set) => ({
  medRepBookingData: {},
  fetchMedRepBookings: async (id, startDate, endDate) => {
    try {
      const response = await getMedRepBooking(id, startDate, endDate);
      set({ medRepBookingData: response.data });
    } catch (error) {}
  },
}));

export const useIVREngagements = create((set) => ({
  IVRBookingData: [],
  IVRLoading: false,
  fetchIVRBooking: async (start, end) => {
    set({ IVRLoading: true });
    try {
      const response = await getIVRBookings(start, end);
      set({ IVRBookingData: response.data });
    } catch (error) {
    } finally {
      set({ IVRLoading: false });
    }
  },
}));
